import { Card, CardContent } from "@/components/ui/card";
import { DollarSign, TrendingUp, Briefcase } from "lucide-react";
import { formatCurrency } from '@/utils/formatters';

interface RevenueStatsProps {
  totalRevenue: number;
  averageRevenue?: number;
  totalClients?: number;
  showAverage?: boolean;
  showClients?: boolean;
}

export const RevenueStats = ({ 
  totalRevenue, 
  averageRevenue = 0,
  totalClients = 0,
  showAverage = true,
  showClients = true 
}: RevenueStatsProps) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      <Card>
        <CardContent className="pt-6">
          <div className="text-center space-y-2">
            <DollarSign className="h-8 w-8 text-primary mx-auto" />
            <h3 className="text-lg font-medium">Total Revenue</h3>
            <p className="text-2xl font-bold">{formatCurrency(totalRevenue)}</p>
          </div>
        </CardContent>
      </Card>
      
      {showAverage && (
        <Card>
          <CardContent className="pt-6">
            <div className="text-center space-y-2">
              <TrendingUp className="h-8 w-8 text-green-500 mx-auto" />
              <h3 className="text-lg font-medium">Avg. Monthly Revenue</h3>
              <p className="text-2xl font-bold">{formatCurrency(averageRevenue)}</p>
            </div>
          </CardContent>
        </Card>
      )}
      
      {showClients && (
        <Card>
          <CardContent className="pt-6">
            <div className="text-center space-y-2">
              <Briefcase className="h-8 w-8 text-amber-500 mx-auto" />
              <h3 className="text-lg font-medium">Total Clients</h3>
              <p className="text-2xl font-bold">{totalClients}</p>
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
